/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AckWhitelistCommand = {
    sequenceNumber: number;
    result: AckWhitelistCommand.result;
    error?: string;
};
export namespace AckWhitelistCommand {
    export enum result {
        OK = 'Ok',
        CRC_ERR = 'CrcErr',
        DECODE_ERR = 'DecodeErr',
    }
}

